/* eslint-disable */

/**
 * Simple timer for an OOP way of handling timer functions.
 *
 * This class wraps around JavaScript's native `setTimeout` function.
 * Timer functions include: start, stop, and reset interval.
 *
 * Args:
 *      callback (Function): The callback function to fire when timer completes
 *      time (Number): Timeout interval in milliseconds
 *
 * Returns:
 *      (Object) Creates a new 'timer' instance.
 *
 * Example:
 *      mounted() {
 *          this.myTimer = new Timer(transitionToNextSlide, 5000);
 *          this.myTimer.start();
 *      },
 *
 *      methods: {
 *          onPause() {
 *              this.myTimer.stop();
 *          },
 *
 *          onResume() {
 *              this.myTimer.start();
 *          },
 *
 *          // changes timer to 2 seconds:
 *          onChangeSlideInterval() {
 *              this.myTimer.reset(2000);
 *          }
 *      }
 */
export default class Timer {
    constructor(callback, time) {
        this.time = time;
        this.callback = callback;
        this.timerObj = null;
    }

    // start timer:
    start() {
        if (!this.timerObj) {
            this.stop();
            this.timerObj = setInterval(this.callback, this.time);
        }
    }

    // stop timer:
    stop() {
        if (this.timerObj) {
            clearInterval(this.timerObj);
            this.timerObj = null;
        }
    }

    // reset interval (stops current timer; starts new one)
    reset(time) {
        this.time = time;
        this.stop();
        this.start();
    }
}
